module.exports = __webpack_public_path__ + "static/media/financehead.8c983d77.jpg";